// extracted by mini-css-extract-plugin
export default {"wrapper":"inputWithLabel_wrapper__keNH7","label":"inputWithLabel_label__ldUrB"};